import { render, staticRenderFns } from "./ParentsForm.vue?vue&type=template&id=59331f2e&scoped=true"
import script from "./ParentsForm.vue?vue&type=script&lang=js"
export * from "./ParentsForm.vue?vue&type=script&lang=js"
import style0 from "./ParentsForm.vue?vue&type=style&index=0&id=59331f2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59331f2e",
  null
  
)

export default component.exports